// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wOMH","footer":"styles_footer__QFahz","passCodeTooltip":"styles_passCodeTooltip__1uV0p"};